import React from 'react';

import { QStack } from '@captivateiq/quotient';

import { ChatViewEnum, useAIShellContext } from '@captivateiq/assistant/AIShellContext';
import { BrowserView } from './BrowserView';
import { ChatView } from './ChatView';
import { IntroView } from './IntroView';

export const ChatTab = () => {
  const { chatView } = useAIShellContext();

  return (
    <QStack
      direction="column"
      sx={{
        alignItems: 'stretch',
        height: '100%',
      }}
    >
      {
        {
          [ChatViewEnum.BROWSER]: <BrowserView />,
          [ChatViewEnum.INTRO]: <IntroView />,
          [ChatViewEnum.CHAT]: <ChatView />,
        }[chatView]
      }
    </QStack>
  );
};
